import React from "react";

const MAX_TILT_DEG = 6;

export const handleTiltMove = (e: React.MouseEvent<HTMLElement>) => {
  const el = e.currentTarget;
  const rect = el.getBoundingClientRect();
  const x = (e.clientX - rect.left) / rect.width;
  const y = (e.clientY - rect.top) / rect.height;

  el.style.setProperty("--mx", `${x * 100}%`);
  el.style.setProperty("--my", `${y * 100}%`);
  el.style.setProperty("--rx", `${(0.5 - y) * MAX_TILT_DEG}deg`);
  el.style.setProperty("--ry", `${(x - 0.5) * MAX_TILT_DEG}deg`);
};

export const handleTiltLeave = (e: React.MouseEvent<HTMLElement>) => {
  const el = e.currentTarget;
  el.style.setProperty("--rx", "0deg");
  el.style.setProperty("--ry", "0deg");
};
